import React from 'react'
import styles from './Form.module.css'
import { useForm } from 'react-hook-form'
import emailjs, { init } from 'emailjs-com';

init("user_TWwmYKUEzP7rquzKVAJLx");

export default function Form() {
    const { register, handleSubmit, errors } = useForm();
    const onSubmit = (data) => {
      alert(`Thank you for your message from ${data.email}`);
      const templateId = 'template_7q9e562';
      const serviceID = 'service_ftujz1x';
      sendFeedback(serviceID, templateId, { name: data.username, textmessage: data.textmessage, email: data.email, number: data.contact_number })
  }

  const sendFeedback = (serviceID, templateId, variables) => {
    emailjs.send(
        serviceID, templateId,
        variables
    ).then(res => {
        console.log('Email successfully sent!')
    })
        .catch(err => console.error('There has been an error.  Here some thoughts on the error that occured:', err))
    }
    return (
        <form className={styles.container} onSubmit={handleSubmit(onSubmit)}>
            <div className={styles.contact}>
                <div className={styles.inputs}>
                    <input type="text" placeholder="Таны нэр" name="username" 
                                    ref={register({required: 'хоосон',
                                                  minLength: {
                                                    value: 2,
                                                    message: 'хэт богино'
                                                  },
                                                  maxLength: {
                                                    value: 34,
                                                    message: 'хэт урт'
                                                  }
                                                  })} />
                    {errors.username && <p className="error_text">{errors.username.message}</p>}
                    <input type="text" placeholder="Имэйл" name="email" 
                                    ref={register({required: true,
                                                  pattern: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
                                                  })} /> 
                                  {errors.email && <p className="error_text">Имэйл буруу байна</p>}
                    <input type="text" placeholder="Утасны дугаар" name="contact_number" id="contact_number" ref={register} />

                </div>
                <div className={styles.right}>
                <textarea placeholder="Энд явуулах мэссэжээ бичнэ үү!" name="textmessage"  
                                    ref={register({required: 'Та текстээ оруулна уу!',
                                                   minLength: {
                                                     value: 5,
                                                     message: "хэт богино"
                                                   }
                                    })} />
                                    {errors.textmessage && <p className="error_text">{errors.textmessage.message}</p>}
                    <button type="submit"> Илгээх </button>

                </div>
                
            </div>

        </form>
    )
}
